const CACHE_KEY = "kindler_theme";
const media = window.matchMedia("(prefers-color-scheme: dark)");

let chosen = null;
try {
  chosen = localStorage.getItem(CACHE_KEY);
} catch {
  chosen = null;
}

const resolve = () => (chosen || (media.matches ? "dark" : "light"));

const paint = () => {
  document.documentElement.classList.toggle("dark", resolve() === "dark");
  window.dispatchEvent(new Event("kindler-theme"));
};

export function setThemeChoice(theme) {
  chosen = theme === "dark" || theme === "light" ? theme : null;
  try {
    if (chosen) localStorage.setItem(CACHE_KEY, chosen);
    else localStorage.removeItem(CACHE_KEY);
  } catch {
    // localStorage unavailable, ignore
  }
  paint();
}

export const currentTheme = resolve;

media.addEventListener("change", () => {
  if (!chosen) paint();
});

paint();
